var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58286 15.4139C7.20796 15.0388 6.99736 14.5302 6.99736 13.9999C6.99736 13.4695 7.20796 12.9609 7.58286 12.5859L15.6409 4.52987C15.8285 4.34237 16.0828 4.23706 16.3479 4.23706C16.6131 4.23706 16.8674 4.34237 17.0549 4.52987L17.7619 5.23686C17.9494 5.42436 18.0547 5.67867 18.0547 5.94386C18.0547 6.20897 17.9494 6.46327 17.7619 6.65087L10.4119 14.0019L17.7619 21.3518C17.9494 21.5394 18.0547 21.7937 18.0547 22.0588C18.0547 22.324 17.9494 22.5783 17.7619 22.7658L17.0549 23.4728C16.8674 23.6603 16.6131 23.7656 16.3479 23.7656C16.0828 23.7656 15.8285 23.6603 15.6409 23.4728L7.58286 15.4139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev-icon.cd1c1aa2d81630792d984e21557d1d2e.svg";
export { ForwardRef as ReactComponent };